const TotalPackageContentLoader = () => {
  return (
    <div className="p-5 w-full bg-white rounded-lg shadow-[0px_0px_8px_rgba(166,166,166,0.25)]">
      <div className="flex justify-between">
        <div className="w-36 h-5 bg-light_gray rounded-sm animate-pulse"></div>
        <div className="w-16 h-5 bg-light_gray rounded-sm animate-pulse"></div>
      </div>

      <div className="space-y-3 mt-9">
        <div className="h-11 bg-light_gray rounded-sm animate-pulse"></div>
        <div className="h-11 bg-light_gray rounded-sm animate-pulse"></div>
      </div>
    </div>
  );
};

export default TotalPackageContentLoader;
